module.exports = __webpack_public_path__ + "static/media/danny1.8b2df9a2.jpg";